import React, { Component } from "react";
import "./WidgetPincodeProductDashboard.css";
import axios from "axios";
class WidgetPincodeSmartDashboard extends Component {
  constructor({ storeID }) {
    super();
    this.state = {
      storeID: storeID,
      result: [],
      OnlineSalesIncludingTaxDay: 0,
      OnlineSalesIncludingTaxWeek: 0,
      OnlineSalesIncludingTaxMonth: 0,
      OfflineSalesIncludingTaxDay: 0,
      OfflineSalesIncludingTaxWeek: 0,
      OfflineSalesIncludingTaxMonth: 0,
      TotalSalesIncludingTaxDay: 0,
      TotalSalesIncludingTaxWeek: 0,
      TotalSalesIncludingTaxMonth: 0,
      OnlineSalesIncludingTaxCohort1Day: 0,
      OnlineSalesIncludingTaxCohort1Week: 0,
      OnlineSalesIncludingTaxCohort1Month: 0,
      OnlineSalesIncludingTaxCohort2Day: 0,
      OnlineSalesIncludingTaxCohort2Week: 0,
      OnlineSalesIncludingTaxCohort2Month: 0,
      OnlineSalesSMARTDay: 0,
      OnlineSalesSMARTWeek: 0,
      OnlineSalesSMARTMonth: 0,
      OfflineSalesSMARTDay: 0,
      OfflineSalesSMARTWeek: 0,
      OfflineSalesSMARTMonth: 0,
      TotalSalesSMARTDay: 0,
      TotalSalesSMARTWeek: 0,
      TotalSalesSMARTMonth: 0,
      COGsChohort1Day: 0,
      COGsChohort1Week: 0,
      COGsChohort1Month: 0,
      MarginsCohort1Day: 0,
      MarginsCohort1Week: 0,
      MarginsCohort1Month: 0,
      COGsChohort2Day: 0,
      COGsChohort2Week: 0,
      COGsChohort2Month: 0,
      MarginsCohort2Day: 0,
      MarginsCohort2Week: 0,
      MarginsCohort2Month: 0,
      TotalMarginsSmartItemOnlineSalesDay: 0,
      TotalMarginsSmartItemOnlineSalesWeek: 0,
      TotalMarginsSmartItemOnlineSalesMonth: 0,
      COGsOfflineSmartDay: 0,
      COGsOfflineSmartWeek: 0,
      COGsOfflineSmartMonth: 0,
      MarginOfflineSmartDay: 0,
      MarginOfflineSmartWeek: 0,
      MarginOfflineSmartMonth: 0,
      TotalMarginOnlineOfflineSmartDay: 0,
      TotalMarginOnlineOfflineSmartWeek: 0,
      TotalMarginOnlineOfflineSmartMonth: 0,
      OnlineSalesNonSmartDay: 0,
      OnlineSalesNonSmartWeek: 0,
      OnlineSalesNonSmartMonth: 0,
      CommissionNonSmartDay: 0,
      CommissionNonSmartWeek: 0,
      CommissionNonSmartMonth: 0,
      //   PurchaseSmartItemsDay: 0,
      //   PurchaseSmartItemsWeek: 0,
      //   PurchaseSmartItemsMonth: 0,
      GRNSmartDay: 0,
      GRNSmartWeek: 0,
      GRNSmartMonth: 0,
      ValueOfAvailableInventory: 0,
      TotalValueHeldForSmartItems: 0,
      ValueOfRequiredInventory: 0,
      ValueToBeAccumulatedForIdealAssortment: 0,
      LastMarginSettledAmount: 0,
      ExcessFundsSettlementAmount: 0,
      TotalSettlementAmount: 0,
      FundHeld: 0,
      day: "",
      week: "",
      month: "",
      showSection: false,
      // InventoryAvailbaleInStore: 0,
      // FundHeld: 0,
      TotalValueOfSmartItems: 0,
      ValueOfRequiredInventory: 0,
      ValueToBeAccumulatedForIdealAssortment: 0,
      LastMarginSettledAmount: 0,
      ExcessFundsSettlementAmount: 0,
      TotalSettlementAmount: 0,
      OptinalAssormentSKUCount: 0,
      MarginSettledOn: "",
      ExcessAmountSettledOn: "",
      TotalSettlementMadeOn: "",
      expiry_date: "",
      expiry_raised_fnv: 0,
      wtd_expiry_raised_fnv: 0,
      mtd_expiry_raised_fnv: 0,
      ltd_expiry_raised_fnv: 0,
      expiry_raised_dbe: 0,
      wtd_expiry_raised_dbe: 0,
      mtd_expiry_raised_dbe: 0,
      ltd_expiry_raised_dbe: 0,
      expiry_raised_others: 0,
      wtd_expiry_raised_others: 0,
      mtd_expiry_raised_others: 0,
      ltd_expiry_raised_others: 0,
      expiry_raised_total: 0,
      wtd_expiry_raised_total: 0,
      mtd_expiry_raised_total: 0,
      ltd_expiry_raised_total: 0,
      expiry_approved_fnv: 0,
      wtd_expiry_approved_fnv: 0,
      mtd_expiry_approved_fnv: 0,
      ltd_expiry_approved_fnv: 0,
      expiry_approved_dbe: 0,
      wtd_expiry_approved_dbe: 0,
      mtd_expiry_approved_dbe: 0,
      ltd_expiry_approved_dbe: 0,
      expiry_approved_others: 0,
      wtd_expiry_approved_others: 0,
      mtd_expiry_approved_others: 0,
      ltd_expiry_approved_others: 0,
      expiry_approved_total: 0,
      wtd_expiry_approved_total: 0,
      mtd_expiry_approved_total: 0,
      ltd_expiry_approved_total: 0,
      last_margin_settled_date: "",

      // TargetInvestment: 0,
      // TotalSKUToBeSupplied: 0,
      // InventoryOfSmartSKU: 0,
      // FundHeld: 0,
      // ShortFallAmountToBeCreditedToPincode: 0,
    };
  }

  async componentDidMount() {
    // console.log("WidgetPincodeProductDashboard componentDidMount");
    this.loadData(this.state.storeID);
  }

  removeDecimals(str) {
    if (typeof str !== "string") str = String(str);
    // Remove commas and spaces if any
    str = str.replace(/,/g, "").trim();
    // Convert to number and truncate decimals
    return Math.trunc(Number(str)) || 0;
  }

  async loadData(storeID) {
    // console.log("storeID", storeID);
    // let storeids = [];
    // let OnlineSalesIncludingTaxDay = 0;
    // let OnlineSalesIncludingTaxWeek = 0;
    // let OnlineSalesIncludingTaxMonth = 0;
    // let OfflineSalesIncludingTaxDay = 0;
    // let OfflineSalesIncludingTaxWeek = 0;
    // let OfflineSalesIncludingTaxMonth = 0;
    // let TotalSalesIncludingTaxDay = 0;
    // let TotalSalesIncludingTaxWeek = 0;
    // let TotalSalesIncludingTaxMonth = 0;
    // let OnlineSalesIncludingTaxCohort1Day = 0;
    // let OnlineSalesIncludingTaxCohort1Week = 0;
    // let OnlineSalesIncludingTaxCohort1Month = 0;
    // let OnlineSalesIncludingTaxCohort2Day = 0;
    // let OnlineSalesIncludingTaxCohort2Week = 0;
    // let OnlineSalesIncludingTaxCohort2Month = 0;
    // let OnlineSalesSMARTDay = 0;
    // let OnlineSalesSMARTWeek = 0;
    // let OnlineSalesSMARTMonth = 0;
    // let OfflineSalesSMARTDay = 0;
    // let OfflineSalesSMARTWeek = 0;
    // let OfflineSalesSMARTMonth = 0;
    // let TotalSalesSMARTDay = 0;
    // let TotalSalesSMARTWeek = 0;
    // let TotalSalesSMARTMonth = 0;
    // let COGsChohort1Day = 0;
    // let COGsChohort1Week = 0;
    // let COGsChohort1Month = 0;
    // let MarginsCohort1Day = 0;
    // let MarginsCohort1Week = 0;
    // let MarginsCohort1Month = 0;
    // let COGsChohort2Day = 0;
    // let COGsChohort2Week = 0;
    // let COGsChohort2Month = 0;
    // let MarginsCohort2Day = 0;
    // let MarginsCohort2Week = 0;
    // let MarginsCohort2Month = 0;
    // let TotalMarginsSmartItemOnlineSalesDay = 0;
    // let TotalMarginsSmartItemOnlineSalesWeek = 0;
    // let TotalMarginsSmartItemOnlineSalesMonth = 0;
    // let COGsOfflineSmartDay = 0;
    // let COGsOfflineSmartWeek = 0;
    // let COGsOfflineSmartMonth = 0;
    // let MarginOfflineSmartDay = 0;
    // let MarginOfflineSmartWeek = 0;
    // let MarginOfflineSmartMonth = 0;
    // let TotalMarginOnlineOfflineSmartDay = 0;
    // let TotalMarginOnlineOfflineSmartWeek = 0;
    // let TotalMarginOnlineOfflineSmartMonth = 0;
    // let OnlineSalesNonSmartDay = 0;
    // let OnlineSalesNonSmartWeek = 0;
    // let OnlineSalesNonSmartMonth = 0;
    // let CommissionNonSmartDay = 0;
    // let CommissionNonSmartWeek = 0;
    // let CommissionNonSmartMonth = 0;
    // let PurchaseSmartItemsDay = 0;
    // let PurchaseSmartItemsWeek = 0;
    // let PurchaseSmartItemsMonth = 0;
    // let GRNSmartDay = 0;
    // let GRNSmartWeek = 0;
    // let GRNSmartMonth = 0;
    // stores.map((s) => {
    //   if (s.key !== "") {
    //     storeids.push(s.key);
    //   }
    // });
    // console.log(storeids);
    // let result = await getPincodeProductDashboard(storeids);

    let result = await axios.post(
      "https://backend-197598313260.asia-south1.run.app/v1/reports/pincode/sales/dashboard",
      {
        storeId: storeID,
      },
      {
        headers: {
          "Content-Type": "application/json", // Explicitly set the content type
        },
      }
    );
    // console.log("WidgetPincodeProductDashboard result", result);
    let tmp = [];
    if (
      result &&
      result.data &&
      result.data.sellerDashboard
      //   &&
      //   result.data.result.length > 0
    ) {
      tmp = result.data.sellerDashboard;
      this.setState({
        showSection: true,
        day: tmp.Day ? tmp.Day : "",
        week: tmp.Week ? tmp.Week : "",
        month: tmp.Month ? tmp.Month : "",
        OnlineSalesIncludingTaxDay: tmp.OnlineSalesIncludingTaxDay
          ? this.removeDecimals(tmp.OnlineSalesIncludingTaxDay)
          : "",
        OnlineSalesIncludingTaxWeek: tmp.OnlineSalesIncludingTaxWeek
          ? this.removeDecimals(tmp.OnlineSalesIncludingTaxWeek)
          : "",
        OnlineSalesIncludingTaxMonth: tmp.OnlineSalesIncludingTaxMonth
          ? this.removeDecimals(tmp.OnlineSalesIncludingTaxMonth)
          : "",
        OfflineSalesIncludingTaxDay: tmp.OfflineSalesIncludingTaxDay
          ? this.removeDecimals(tmp.OfflineSalesIncludingTaxDay)
          : "",
        OfflineSalesIncludingTaxWeek: tmp.OfflineSalesIncludingTaxWeek
          ? this.removeDecimals(tmp.OfflineSalesIncludingTaxWeek)
          : "",
        OfflineSalesIncludingTaxMonth: tmp.OfflineSalesIncludingTaxMonth
          ? this.removeDecimals(tmp.OfflineSalesIncludingTaxMonth)
          : "",
        TotalSalesIncludingTaxDay: tmp.TotalSalesIncludingTaxDay
          ? this.removeDecimals(tmp.TotalSalesIncludingTaxDay)
          : "",
        TotalSalesIncludingTaxWeek: tmp.TotalSalesIncludingTaxWeek
          ? this.removeDecimals(tmp.TotalSalesIncludingTaxWeek)
          : "",
        TotalSalesIncludingTaxMonth: tmp.TotalSalesIncludingTaxMonth
          ? this.removeDecimals(tmp.TotalSalesIncludingTaxMonth)
          : "",
        OnlineSalesIncludingTaxCohort1Day: tmp.OnlineSalesIncludingTaxCohort1Day
          ? this.removeDecimals(tmp.OnlineSalesIncludingTaxCohort1Day)
          : "",
        OnlineSalesIncludingTaxCohort1Week: tmp.OnlineSalesIncludingTaxCohort1Week
          ? this.removeDecimals(tmp.OnlineSalesIncludingTaxCohort1Week)
          : "",
        OnlineSalesIncludingTaxCohort1Month: tmp.OnlineSalesIncludingTaxCohort1Month
          ? this.removeDecimals(tmp.OnlineSalesIncludingTaxCohort1Month)
          : "",
        OnlineSalesIncludingTaxCohort2Day: tmp.OnlineSalesIncludingTaxCohort2Day
          ? this.removeDecimals(tmp.OnlineSalesIncludingTaxCohort2Day)
          : "",
        OnlineSalesIncludingTaxCohort2Week: tmp.OnlineSalesIncludingTaxCohort2Week
          ? this.removeDecimals(tmp.OnlineSalesIncludingTaxCohort2Week)
          : "",
        OnlineSalesIncludingTaxCohort2Month: tmp.OnlineSalesIncludingTaxCohort2Month
          ? this.removeDecimals(tmp.OnlineSalesIncludingTaxCohort2Month)
          : "",
        OnlineSalesSMARTDay: tmp.OnlineSalesSMARTDay
          ? this.removeDecimals(tmp.OnlineSalesSMARTDay)
          : "",
        OnlineSalesSMARTWeek: tmp.OnlineSalesSMARTWeek
          ? this.removeDecimals(tmp.OnlineSalesSMARTWeek)
          : "",
        OnlineSalesSMARTMonth: tmp.OnlineSalesSMARTMonth
          ? this.removeDecimals(tmp.OnlineSalesSMARTMonth)
          : "",
        OfflineSalesSMARTDay: tmp.OfflineSalesSMARTDay
          ? this.removeDecimals(tmp.OfflineSalesSMARTDay)
          : "",
        OfflineSalesSMARTWeek: tmp.OfflineSalesSMARTWeek
          ? this.removeDecimals(tmp.OfflineSalesSMARTWeek)
          : "",
        OfflineSalesSMARTMonth: tmp.OfflineSalesSMARTMonth
          ? this.removeDecimals(tmp.OfflineSalesSMARTMonth)
          : "",
        TotalSalesSMARTDay: tmp.TotalSalesSMARTDay
          ? this.removeDecimals(tmp.TotalSalesSMARTDay)
          : "",
        TotalSalesSMARTWeek: tmp.TotalSalesSMARTWeek
          ? this.removeDecimals(tmp.TotalSalesSMARTWeek)
          : "",
        TotalSalesSMARTMonth: tmp.TotalSalesSMARTMonth
          ? this.removeDecimals(tmp.TotalSalesSMARTMonth)
          : "",
        COGsChohort1Day: tmp.COGsChohort1Day
          ? this.removeDecimals(tmp.COGsChohort1Day)
          : "",
        COGsChohort1Week: tmp.COGsChohort1Week
          ? this.removeDecimals(tmp.COGsChohort1Week)
          : "",
        COGsChohort1Month: tmp.COGsChohort1Month
          ? this.removeDecimals(tmp.COGsChohort1Month)
          : "",
        MarginsCohort1Day: tmp.MarginsCohort1Day
          ? this.removeDecimals(tmp.MarginsCohort1Day)
          : "",
        MarginsCohort1Week: tmp.MarginsCohort1Week
          ? this.removeDecimals(tmp.MarginsCohort1Week)
          : "",
        MarginsCohort1Month: tmp.MarginsCohort1Month
          ? this.removeDecimals(tmp.MarginsCohort1Month)
          : "",
        COGsChohort2Day: tmp.COGsChohort2Day
          ? this.removeDecimals(tmp.COGsChohort2Day)
          : "",
        COGsChohort2Week: tmp.COGsChohort2Week
          ? this.removeDecimals(tmp.COGsChohort2Week)
          : "",
        COGsChohort2Month: tmp.COGsChohort2Month
          ? this.removeDecimals(tmp.COGsChohort2Month)
          : "",
        MarginsCohort2Day: tmp.MarginsCohort2Day
          ? this.removeDecimals(tmp.MarginsCohort2Day)
          : "",
        MarginsCohort2Week: tmp.MarginsCohort2Week
          ? this.removeDecimals(tmp.MarginsCohort2Week)
          : "",
        MarginsCohort2Month: tmp.MarginsCohort2Month
          ? this.removeDecimals(tmp.MarginsCohort2Month)
          : "",
        TotalMarginsSmartItemOnlineSalesDay: tmp.TotalMarginsSmartItemOnlineSalesDay
          ? this.removeDecimals(tmp.TotalMarginsSmartItemOnlineSalesDay)
          : "",
        TotalMarginsSmartItemOnlineSalesWeek: tmp.TotalMarginsSmartItemOnlineSalesWeek
          ? this.removeDecimals(tmp.TotalMarginsSmartItemOnlineSalesWeek)
          : "",
        TotalMarginsSmartItemOnlineSalesMonth: tmp.TotalMarginsSmartItemOnlineSalesMonth
          ? this.removeDecimals(tmp.TotalMarginsSmartItemOnlineSalesMonth)
          : "",
        COGsOfflineSmartDay: tmp.COGsOfflineSmartDay
          ? this.removeDecimals(tmp.COGsOfflineSmartDay)
          : "",
        COGsOfflineSmartWeek: tmp.COGsOfflineSmartWeek
          ? this.removeDecimals(tmp.COGsOfflineSmartWeek)
          : "",
        COGsOfflineSmartMonth: tmp.COGsOfflineSmartMonth
          ? this.removeDecimals(tmp.COGsOfflineSmartMonth)
          : "",
        MarginOfflineSmartDay: tmp.MarginOfflineSmartDay
          ? this.removeDecimals(tmp.MarginOfflineSmartDay)
          : "",
        MarginOfflineSmartWeek: tmp.MarginOfflineSmartWeek
          ? this.removeDecimals(tmp.MarginOfflineSmartWeek)
          : "",
        MarginOfflineSmartMonth: tmp.MarginOfflineSmartMonth
          ? this.removeDecimals(tmp.MarginOfflineSmartMonth)
          : "",
        TotalMarginOnlineOfflineSmartDay: tmp.TotalMarginOnlineOfflineSmartDay
          ? this.removeDecimals(tmp.TotalMarginOnlineOfflineSmartDay)
          : "",
        TotalMarginOnlineOfflineSmartWeek: tmp.TotalMarginOnlineOfflineSmartWeek
          ? this.removeDecimals(tmp.TotalMarginOnlineOfflineSmartWeek)
          : "",
        TotalMarginOnlineOfflineSmartMonth: tmp.TotalMarginOnlineOfflineSmartMonth
          ? this.removeDecimals(tmp.TotalMarginOnlineOfflineSmartMonth)
          : "",
        OnlineSalesNonSmartDay: tmp.OnlineSalesNonSmartDay
          ? this.removeDecimals(tmp.OnlineSalesNonSmartDay)
          : "",
        OnlineSalesNonSmartWeek: tmp.OnlineSalesNonSmartWeek
          ? this.removeDecimals(tmp.OnlineSalesNonSmartWeek)
          : "",
        OnlineSalesNonSmartMonth: tmp.OnlineSalesNonSmartMonth
          ? this.removeDecimals(tmp.OnlineSalesNonSmartMonth)
          : "",
        CommissionNonSmartDay: tmp.CommissionNonSmartDay
          ? this.removeDecimals(tmp.CommissionNonSmartDay)
          : "",
        CommissionNonSmartWeek: tmp.CommissionNonSmartWeek
          ? this.removeDecimals(tmp.CommissionNonSmartWeek)
          : "",
        CommissionNonSmartMonth: tmp.CommissionNonSmartMonth
          ? this.removeDecimals(tmp.CommissionNonSmartMonth)
          : "",
        // PurchaseSmartItemsDay: tmp.PurchaseSmartItemsDay
        //   ? tmp.PurchaseSmartItemsDay
        //   : "",
        // PurchaseSmartItemsWeek: tmp.PurchaseSmartItemsWeek
        //   ? tmp.PurchaseSmartItemsWeek
        //   : "",
        // PurchaseSmartItemsMonth: tmp.PurchaseSmartItemsMonth
        //   ? tmp.PurchaseSmartItemsMonth
        //   : "",
        GRNSmartDay: tmp.GRNSmartDay
          ? this.removeDecimals(tmp.GRNSmartDay)
          : "",
        GRNSmartWeek: tmp.GRNSmartWeek
          ? this.removeDecimals(tmp.GRNSmartWeek)
          : "",
        GRNSmartMonth: tmp.GRNSmartMonth
          ? this.removeDecimals(tmp.GRNSmartMonth)
          : "",
        ValueOfAvailableInventory: tmp.ValueOfAvailableInventory
          ? this.removeDecimals(tmp.ValueOfAvailableInventory)
          : "",
        FundHeld: tmp.FundHeld ? this.removeDecimals(tmp.FundHeld) : "",
        TotalValueHeldForSmartItems: tmp.TotalValueHeldForSmartItems
          ? this.removeDecimals(tmp.TotalValueHeldForSmartItems)
          : "",
        ValueOfRequiredInventory: tmp.ValueOfRequiredInventory
          ? this.removeDecimals(tmp.ValueOfRequiredInventory)
          : "",
        ValueToBeAccumulatedForIdealAssortment: tmp.ValueToBeAccumulatedForIdealAssortment
          ? this.removeDecimals(tmp.ValueToBeAccumulatedForIdealAssortment)
          : "",
        LastMarginSettledAmount: tmp.LastMarginSettledAmount
          ? this.removeDecimals(tmp.LastMarginSettledAmount)
          : "",
        ExcessFundsSettlementAmount: tmp.ExcessFundsSettlementAmount
          ? this.removeDecimals(tmp.ExcessFundsSettlementAmount)
          : "",
        TotalSettlementAmount: tmp.TotalSettlementAmount
          ? this.removeDecimals(tmp.TotalSettlementAmount)
          : "",

        // InventoryAvailbaleInStore: tmp.ValueOfAvailableInventory
        //   ? this.removeDecimals(tmp.ValueOfAvailableInventory)
        //   : 0,
        // FundHeld: tmp.FundHeld ? this.removeDecimals(tmp.FundHeld ): 0,
        TotalValueOfSmartItems: tmp.TotalValueOfSmartItems
          ? this.removeDecimals(tmp.TotalValueOfSmartItems)
          : 0,
        ValueOfRequiredInventory: tmp.ValueOfRequiredInventory
          ? this.removeDecimals(tmp.ValueOfRequiredInventory)
          : 0,
        ValueToBeAccumulatedForIdealAssortment: tmp.ValueToBeAccumulatedForIdealAssortment
          ? this.removeDecimals(tmp.ValueToBeAccumulatedForIdealAssortment)
          : 0,
        LastMarginSettledAmount: tmp.LastMarginSettledAmount
          ? this.removeDecimals(tmp.LastMarginSettledAmount)
          : 0,
        ExcessFundsSettlementAmount: tmp.ExcessFundsSettlementAmount
          ? this.removeDecimals(tmp.ExcessFundsSettlementAmount)
          : 0,
        TotalSettlementAmount: tmp.TotalSettlementAmount
          ? this.removeDecimals(tmp.TotalSettlementAmount)
          : 0,
        OptinalAssormentSKUCount: tmp.OptinalAssormentSKUCount
          ? this.removeDecimals(tmp.OptinalAssormentSKUCount)
          : 0,
        MarginSettledOn: tmp.MarginSettledOn ? tmp.MarginSettledOn : "",
        ExcessAmountSettledOn: tmp.ExcessAmountSettledOn
          ? tmp.ExcessAmountSettledOn
          : "",
        TotalSettlementMadeOn: tmp.TotalSettlementMadeOn
          ? tmp.TotalSettlementMadeOn
          : "",

        expiry_date: tmp.expiry_date ? tmp.expiry_date : "",
        expiry_raised_fnv: tmp.expiry_raised_fnv
          ? this.removeDecimals(tmp.expiry_raised_fnv)
          : "",
        wtd_expiry_raised_fnv: tmp.wtd_expiry_raised_fnv
          ? this.removeDecimals(tmp.wtd_expiry_raised_fnv)
          : "",
        mtd_expiry_raised_fnv: tmp.mtd_expiry_raised_fnv
          ? this.removeDecimals(tmp.mtd_expiry_raised_fnv)
          : "",
        ltd_expiry_raised_fnv: tmp.ltd_expiry_raised_fnv
          ? this.removeDecimals(tmp.ltd_expiry_raised_fnv)
          : "",
        expiry_raised_dbe: tmp.expiry_raised_dbe
          ? this.removeDecimals(tmp.expiry_raised_dbe)
          : "",
        wtd_expiry_raised_dbe: tmp.wtd_expiry_raised_dbe
          ? this.removeDecimals(tmp.wtd_expiry_raised_dbe)
          : "",
        mtd_expiry_raised_dbe: tmp.mtd_expiry_raised_dbe
          ? this.removeDecimals(tmp.mtd_expiry_raised_dbe)
          : "",
        ltd_expiry_raised_dbe: tmp.ltd_expiry_raised_dbe
          ? this.removeDecimals(tmp.ltd_expiry_raised_dbe)
          : "",
        expiry_raised_others: tmp.expiry_raised_others
          ? this.removeDecimals(tmp.expiry_raised_others)
          : "",
        wtd_expiry_raised_others: tmp.wtd_expiry_raised_others
          ? this.removeDecimals(tmp.wtd_expiry_raised_others)
          : "",
        mtd_expiry_raised_others: tmp.mtd_expiry_raised_others
          ? this.removeDecimals(tmp.mtd_expiry_raised_others)
          : "",
        ltd_expiry_raised_others: tmp.ltd_expiry_raised_others
          ? this.removeDecimals(tmp.ltd_expiry_raised_others)
          : "",
        expiry_raised_total: tmp.expiry_raised_total
          ? this.removeDecimals(tmp.expiry_raised_total)
          : "",
        wtd_expiry_raised_total: tmp.wtd_expiry_raised_total
          ? this.removeDecimals(tmp.wtd_expiry_raised_total)
          : "",
        mtd_expiry_raised_total: tmp.mtd_expiry_raised_total
          ? this.removeDecimals(tmp.mtd_expiry_raised_total)
          : "",
        ltd_expiry_raised_total: tmp.ltd_expiry_raised_total
          ? this.removeDecimals(tmp.ltd_expiry_raised_total)
          : "",
        expiry_approved_fnv: tmp.expiry_approved_fnv
          ? this.removeDecimals(tmp.expiry_approved_fnv)
          : "",
        wtd_expiry_approved_fnv: tmp.wtd_expiry_approved_fnv
          ? this.removeDecimals(tmp.wtd_expiry_approved_fnv)
          : "",
        mtd_expiry_approved_fnv: tmp.mtd_expiry_approved_fnv
          ? this.removeDecimals(tmp.mtd_expiry_approved_fnv)
          : "",
        ltd_expiry_approved_fnv: tmp.ltd_expiry_approved_fnv
          ? this.removeDecimals(tmp.ltd_expiry_approved_fnv)
          : "",
        expiry_approved_dbe: tmp.expiry_approved_dbe
          ? this.removeDecimals(tmp.expiry_approved_dbe)
          : "",
        wtd_expiry_approved_dbe: tmp.wtd_expiry_approved_dbe
          ? this.removeDecimals(tmp.wtd_expiry_approved_dbe)
          : "",
        mtd_expiry_approved_dbe: tmp.mtd_expiry_approved_dbe
          ? this.removeDecimals(tmp.mtd_expiry_approved_dbe)
          : "",
        ltd_expiry_approved_dbe: tmp.ltd_expiry_approved_dbe
          ? this.removeDecimals(tmp.ltd_expiry_approved_dbe)
          : "",
        expiry_approved_others: tmp.expiry_approved_others
          ? this.removeDecimals(tmp.expiry_approved_others)
          : "",
        wtd_expiry_approved_others: tmp.wtd_expiry_approved_others
          ? this.removeDecimals(tmp.wtd_expiry_approved_others)
          : "",
        mtd_expiry_approved_others: tmp.mtd_expiry_approved_others
          ? this.removeDecimals(tmp.mtd_expiry_approved_others)
          : "",
        ltd_expiry_approved_others: tmp.ltd_expiry_approved_others
          ? this.removeDecimals(tmp.ltd_expiry_approved_others)
          : "",
        expiry_approved_total: tmp.expiry_approved_total
          ? this.removeDecimals(tmp.expiry_approved_total)
          : "",
        wtd_expiry_approved_total: tmp.wtd_expiry_approved_total
          ? this.removeDecimals(tmp.wtd_expiry_approved_total)
          : "",
        mtd_expiry_approved_total: tmp.mtd_expiry_approved_total
          ? this.removeDecimals(tmp.mtd_expiry_approved_total)
          : "",
        ltd_expiry_approved_total: tmp.ltd_expiry_approved_total
          ? this.removeDecimals(tmp.ltd_expiry_approved_total)
          : "",

        // TargetInvestment: tmp.TargetInvestment
        //   ? this.removeDecimals(tmp.TargetInvestment)
        //   : 0,
        // TotalSKUToBeSupplied: tmp.TotalSKUToBeSupplied
        //   ? this.removeDecimals(tmp.TotalSKUToBeSupplied)
        //   : 0,
        // InventoryOfSmartSKU: tmp.InventoryOfSmartSKU
        //   ? this.removeDecimals(tmp.InventoryOfSmartSKU)
        //   : 0,
        // FundHeld: tmp.FundHeld ? this.removeDecimals(tmp.FundHeld) : 0,
        // ShortFallAmountToBeCreditedToPincode: tmp.ShortFallAmountToBeCreditedToPincode
        //   ? this.removeDecimals(tmp.ShortFallAmountToBeCreditedToPincode)
        //   : 0,
      });
    }
    // console.log(tmp);
  }

  componentWillReceiveProps({ storeID }) {
    // console.log("WidgetPincodeProductDashboard componentWillReceiveProps");

    this.loadData(storeID);
  }

  render() {
    return (
      <>
        {this.state.showSection && (
          <div className="WidgetPincodeProductDashboard-box ">
            <div className="WidgetPincodeProductDashboard-box-header">
              <div className="WidgetPincodeProductDashboard-box-title left">
                Smart dashboard
              </div>
            </div>
            <div className="WidgetPincodeProductDashboard-box-body">
              {(this.state.ValueOfRequiredInventory > 0 ||
                this.state.OptinalAssormentSKUCount > 0 ||
                this.state.ValueOfAvailableInventory > 0 ||
                this.state.FundHeld > 0 ||
                this.state.ValueOfRequiredInventory > 0) && (
                <table className="table table-bordered ">
                  <thead>
                    <tr style={{ backgroundColor: "#f9f9f9 " }}>
                      <th>Target Investment (A)</th>
                      <th>
                        Total SKU that will be supplied (FMCG + FnV + DBE)
                      </th>
                      <th>Inventory of Smart SKU as of yesterday (B)</th>
                      <th>Amount held with Pincode (C)</th>
                      <th>
                        {" "}
                        Shortfall amount to be credited (D) = (A) - (B) - (C){" "}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="align-right">
                        {this.state.ValueOfRequiredInventory}
                      </td>
                      <td className="align-right">
                        {this.state.OptinalAssormentSKUCount}
                      </td>
                      <td className="align-right">
                        {this.state.ValueOfAvailableInventory}
                      </td>
                      <td className="align-right">{this.state.FundHeld}</td>
                      <td className="align-right">
                        {this.state.ValueToBeAccumulatedForIdealAssortment}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
            <div className="WidgetPincodeProductDashboard-box-body">
              <table className="table table-bordered ">
                <thead>
                  <tr style={{ backgroundColor: "#f9f9f9 " }}>
                    <th colSpan={5}>
                      Sales, earnings, commissions and purchases
                    </th>
                  </tr>
                  <tr style={{ backgroundColor: "#f9f9f9 " }}>
                    <th>Sr. No.</th>
                    <th>Particulars</th>
                    <th>Day ({this.state.day})</th>
                    <th>Week ({this.state.week})</th>
                    <th> Month ({this.state.month})</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ backgroundColor: "#f9f9f9 " }}>
                    <td colSpan={5}>Store Sales - All items</td>
                  </tr>
                  <tr>
                    <td>(A)</td>
                    <td>Online Sales (including tax)</td>
                    <td className="align-right">
                      {this.state.OnlineSalesIncludingTaxDay}
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesIncludingTaxWeek}
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesIncludingTaxMonth}
                    </td>
                  </tr>
                  <tr>
                    <td>(B)</td>
                    <td>Offline Sales (including tax)</td>
                    <td className="align-right">
                      {this.state.OfflineSalesIncludingTaxDay}
                    </td>
                    <td className="align-right">
                      {this.state.OfflineSalesIncludingTaxWeek}
                    </td>
                    <td className="align-right">
                      {this.state.OfflineSalesIncludingTaxMonth}
                    </td>
                  </tr>
                  <tr>
                    <td>(C) = (A) + (B)</td>
                    <td>Total Sales (including tax)</td>
                    <td className="align-right">
                      {this.state.TotalSalesIncludingTaxDay}
                    </td>
                    <td className="align-right">
                      {this.state.TotalSalesIncludingTaxWeek}
                    </td>
                    <td className="align-right">
                      {this.state.TotalSalesIncludingTaxMonth}
                    </td>
                  </tr>
                  <tr style={{ backgroundColor: "#f9f9f9 " }}>
                    <td colSpan={5}>Store Sales - Smart items</td>
                  </tr>
                  <tr>
                    <td>(D)</td>
                    <td>
                      Online Sales (including tax) of SMART SKUs - Cohort 1
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesIncludingTaxCohort1Day}
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesIncludingTaxCohort1Week}
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesIncludingTaxCohort1Month}
                    </td>
                  </tr>
                  <tr>
                    <td>(E)</td>
                    <td>
                      Online Sales (including tax) of SMART SKUs - Cohort 2
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesIncludingTaxCohort2Day}
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesIncludingTaxCohort2Week}
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesIncludingTaxCohort2Month}
                    </td>
                  </tr>
                  <tr>
                    <td>(F) = (D) + (E)</td>
                    <td>Total Online Sales (including tax) of SMART SKUs</td>
                    <td className="align-right">
                      {this.state.OnlineSalesSMARTDay}
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesSMARTWeek}
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesSMARTMonth}
                    </td>
                  </tr>
                  <tr>
                    <td>(G)</td>
                    <td>Offline Sales (including tax) of SMART SKUs</td>
                    <td className="align-right">
                      {this.state.OfflineSalesSMARTDay}
                    </td>
                    <td className="align-right">
                      {this.state.OfflineSalesSMARTWeek}
                    </td>
                    <td className="align-right">
                      {this.state.OfflineSalesSMARTMonth}
                    </td>
                  </tr>
                  <tr>
                    <td>(H) = (F) + (G)</td>
                    <td>Total SMART SKUs Sales (including tax)</td>
                    <td className="align-right">
                      {this.state.TotalSalesSMARTDay}
                    </td>
                    <td className="align-right">
                      {this.state.TotalSalesSMARTWeek}
                    </td>
                    <td className="align-right">
                      {this.state.TotalSalesSMARTMonth}
                    </td>
                  </tr>
                  <tr style={{ backgroundColor: "#f9f9f9 " }}>
                    <td colSpan={5}>Earnings - Smart items</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <i>
                        <u>Online Smart Items</u>
                      </i>
                    </td>
                    <td className="align-right"></td>
                    <td className="align-right"></td>
                    <td className="align-right"></td>
                  </tr>
                  <tr>
                    <td>(I)</td>
                    <td>Cost of Goods Sold (excl GST) - Cohort 1 items</td>
                    <td className="align-right">
                      {this.state.COGsChohort1Day}
                    </td>
                    <td className="align-right">
                      {this.state.COGsChohort1Week}
                    </td>
                    <td className="align-right">
                      {this.state.COGsChohort1Month}
                    </td>
                  </tr>
                  <tr>
                    <td>(J)</td>
                    <td>Margins (excl GST) at 7% on Cohort 1 items</td>
                    <td className="align-right">
                      {this.state.MarginsCohort1Day}
                    </td>
                    <td className="align-right">
                      {this.state.MarginsCohort1Week}
                    </td>
                    <td className="align-right">
                      {this.state.MarginsCohort1Month}
                    </td>
                  </tr>
                  <tr>
                    <td>(K)</td>
                    <td>Cost of Goods Sold (excl GST) - Cohort 2* items</td>
                    <td className="align-right">
                      {this.state.COGsChohort2Day}
                    </td>
                    <td className="align-right">
                      {this.state.COGsChohort2Week}
                    </td>
                    <td className="align-right">
                      {this.state.COGsChohort2Month}
                    </td>
                  </tr>
                  <tr>
                    <td>(L)</td>
                    <td>Margins (excl GST) at 3% on Cohort 2 items</td>
                    <td className="align-right">
                      {this.state.MarginsCohort2Day}
                    </td>
                    <td className="align-right">
                      {this.state.MarginsCohort2Week}
                    </td>
                    <td className="align-right">
                      {this.state.MarginsCohort2Month}
                    </td>
                  </tr>
                  <tr>
                    <td>(M) = (J) + (L)</td>
                    <td>
                      Total Margins (excl GST) for Smart items from Online Sales
                    </td>
                    <td className="align-right">
                      {this.state.TotalMarginsSmartItemOnlineSalesDay}
                    </td>
                    <td className="align-right">
                      {" "}
                      {this.state.TotalMarginsSmartItemOnlineSalesWeek}
                    </td>
                    <td className="align-right">
                      {this.state.TotalMarginsSmartItemOnlineSalesMonth}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <i>
                        <u>Offline Smart Items</u>
                      </i>
                    </td>
                    <td className="align-right"></td>
                    <td className="align-right"></td>
                    <td className="align-right"></td>
                  </tr>
                  <tr>
                    <td>(N)</td>
                    <td>Cost of Goods Sold (excl GST)</td>
                    <td className="align-right">
                      {this.state.COGsOfflineSmartDay}
                    </td>
                    <td className="align-right">
                      {this.state.COGsOfflineSmartWeek}
                    </td>
                    <td className="align-right">
                      {this.state.COGsOfflineSmartMonth}
                    </td>
                  </tr>
                  <tr>
                    <td>(O)</td>
                    <td>
                      Margins (excl taxes) for Smart Items from Offline Sales
                    </td>
                    <td className="align-right">
                      {this.state.MarginOfflineSmartDay}
                    </td>
                    <td className="align-right">
                      {this.state.MarginOfflineSmartWeek}
                    </td>
                    <td className="align-right">
                      {this.state.MarginOfflineSmartMonth}
                    </td>
                  </tr>
                  <tr>
                    <td>(P) = (M) + (O)</td>
                    <td>
                      Total Margins (excl taxes) for Online + Offline SMART SKUs
                    </td>
                    <td className="align-right">
                      {this.state.TotalMarginOnlineOfflineSmartDay}
                    </td>
                    <td className="align-right">
                      {this.state.TotalMarginOnlineOfflineSmartWeek}
                    </td>
                    <td className="align-right">
                      {this.state.TotalMarginOnlineOfflineSmartMonth}
                    </td>
                  </tr>
                  <tr style={{ backgroundColor: "#f9f9f9 " }}>
                    <td colSpan={5}>Non - Smart items Online Sales</td>
                  </tr>
                  <tr>
                    <td>(Q)</td>
                    <td>Online Sales (including GST) of NON-SMART SKUs</td>
                    <td className="align-right">
                      {this.state.OnlineSalesNonSmartDay}
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesNonSmartWeek}
                    </td>
                    <td className="align-right">
                      {this.state.OnlineSalesNonSmartMonth}
                    </td>
                  </tr>
                  <tr>
                    <td>(R)</td>
                    <td>Commission on Non - Smart SKUs (excl taxes)</td>
                    <td className="align-right">
                      {this.state.CommissionNonSmartDay}
                    </td>
                    <td className="align-right">
                      {this.state.CommissionNonSmartWeek}
                    </td>
                    <td className="align-right">
                      {this.state.CommissionNonSmartMonth}
                    </td>
                  </tr>
                  <tr style={{ backgroundColor: "#f9f9f9 " }}>
                    <td colSpan={5}>Purchases of Smart Items</td>

                    {/* <td></td>
                    <td>Purchases of Smart Items</td>
                    <td className="align-right">
                      {this.state.PurchaseSmartItemsDay}
                    </td>
                    <td className="align-right">
                      {this.state.PurchaseSmartItemsWeek}
                    </td>
                    <td className="align-right">
                      {this.state.PurchaseSmartItemsMonth}
                    </td> */}
                  </tr>
                  <tr>
                    <td>(S)</td>
                    <td>GRN value for Smart items (including taxes)</td>
                    <td className="align-right">{this.state.GRNSmartDay}</td>
                    <td className="align-right">{this.state.GRNSmartWeek}</td>
                    <td className="align-right">{this.state.GRNSmartMonth}</td>
                  </tr>
                </tbody>
              </table>
              <div>
                <i>* Cohort 2 items refer to milk, ghee, oil and cigarettes</i>
              </div>
              <br />
              {this.state.expiry_date && this.state.expiry_date !== "" && (
                <>
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr style={{ backgroundColor: "#f9f9f9 " }}>
                        <th colSpan={6}>
                          Expiry view till {this.state.expiry_date}
                        </th>
                      </tr>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Particulars</th>
                        <th style={{ width: "15%" }}>Day</th>
                        <th style={{ width: "15%" }}>Week (Tue - Monday)</th>
                        <th style={{ width: "15%" }}>Month</th>
                        <th style={{ width: "15%" }}>Life to date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>(A)</td>
                        <td>Expiry raised:</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>Fruits and Vegetables</td>
                        <td className="align-right">
                          {this.state.expiry_raised_fnv}
                        </td>
                        <td className="align-right">
                          {this.state.wtd_expiry_raised_fnv}
                        </td>
                        <td className="align-right">
                          {this.state.mtd_expiry_raised_fnv}
                        </td>
                        <td className="align-right">
                          {this.state.ltd_expiry_raised_fnv}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>Dairy, Bread and Eggs</td>
                        <td className="align-right">
                          {this.state.expiry_raised_dbe}
                        </td>
                        <td className="align-right">
                          {this.state.wtd_expiry_raised_dbe}
                        </td>
                        <td className="align-right">
                          {this.state.mtd_expiry_raised_dbe}
                        </td>
                        <td className="align-right">
                          {this.state.ltd_expiry_raised_dbe}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>Other Items</td>
                        <td className="align-right">
                          {this.state.expiry_raised_others}
                        </td>
                        <td className="align-right">
                          {this.state.wtd_expiry_raised_others}
                        </td>
                        <td className="align-right">
                          {this.state.mtd_expiry_raised_others}
                        </td>
                        <td className="align-right">
                          {this.state.ltd_expiry_raised_others}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>Total expiry raised</td>
                        <td className="align-right">
                          {this.state.expiry_raised_total}
                        </td>
                        <td className="align-right">
                          {this.state.wtd_expiry_raised_total}
                        </td>
                        <td className="align-right">
                          {this.state.mtd_expiry_raised_total}
                        </td>
                        <td className="align-right">
                          {this.state.ltd_expiry_raised_total}
                        </td>
                      </tr>
                      <tr>
                        <td>(B)</td>
                        <td>Expiry approved:</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>Fruits and Vegetables</td>
                        <td className="align-right">
                          {this.state.expiry_approved_fnv}
                        </td>
                        <td className="align-right">
                          {this.state.wtd_expiry_approved_fnv}
                        </td>
                        <td className="align-right">
                          {this.state.mtd_expiry_approved_fnv}
                        </td>
                        <td className="align-right">
                          {this.state.ltd_expiry_approved_fnv}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>Dairy, Bread and Eggs</td>
                        <td className="align-right">
                          {this.state.expiry_approved_dbe}
                        </td>
                        <td className="align-right">
                          {this.state.wtd_expiry_approved_dbe}
                        </td>
                        <td className="align-right">
                          {this.state.mtd_expiry_approved_dbe}
                        </td>
                        <td className="align-right">
                          {this.state.ltd_expiry_approved_dbe}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>Other Items</td>
                        <td className="align-right">
                          {this.state.expiry_approved_others}
                        </td>
                        <td className="align-right">
                          {this.state.wtd_expiry_approved_others}
                        </td>
                        <td className="align-right">
                          {this.state.mtd_expiry_approved_others}
                        </td>
                        <td className="align-right">
                          {this.state.ltd_expiry_approved_others}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>Total expiry validated</td>
                        <td className="align-right">
                          {this.state.expiry_approved_total}
                        </td>
                        <td className="align-right">
                          {this.state.wtd_expiry_approved_total}
                        </td>
                        <td className="align-right">
                          {this.state.mtd_expiry_approved_total}
                        </td>
                        <td className="align-right">
                          {this.state.ltd_expiry_approved_total}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </>
              )}

              {this.state.FundHeld && this.state.FundHeld !== 0 && (
                <>
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr style={{ backgroundColor: "#f9f9f9 " }}>
                        <th colSpan={4}>
                          Funds, Settlement and Smart- items Inventory view as
                          on {this.state.day}
                        </th>
                      </tr>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Particulars</th>
                        <th>Value (INR)</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>(A)</td>
                        <td>Value of Inventory available in-store</td>
                        <td className="align-right">
                          {this.state.ValueOfAvailableInventory}
                        </td>
                        <td className="align-right"></td>
                      </tr>
                      <tr>
                        <td>(B)</td>
                        <td>Funds held</td>
                        <td className="align-right">{this.state.FundHeld}</td>
                        <td className="align-right"></td>
                      </tr>
                      <tr>
                        <td>(C) = (A) + (B)</td>
                        <td>Total Value held for Smart Items</td>
                        <td className="align-right">
                          {this.state.TotalValueHeldForSmartItems}
                        </td>
                        <td className="align-right"></td>
                      </tr>
                      <tr>
                        <td>(D)</td>
                        <td>
                          Value of required inventory for optimal assortment
                          considering {this.state.OptinalAssormentSKUCount}{" "}
                          SKU's
                        </td>
                        <td className="align-right">
                          {this.state.ValueOfRequiredInventory}
                        </td>
                        <td className="align-right"></td>
                      </tr>
                      <tr>
                        <td>(E) = (D) - (C)</td>
                        <td>To be accumulated for ideal assortment**</td>
                        <td className="align-right">
                          {this.state.ValueToBeAccumulatedForIdealAssortment}
                        </td>
                        <td className="align-right"></td>
                      </tr>
                      <tr>
                        <td>(F)</td>
                        <td>Margins settled on {this.state.MarginSettledOn}</td>
                        <td className="align-right">
                          {this.state.LastMarginSettledAmount}
                        </td>
                        <td className="align-right"></td>
                      </tr>
                      <tr>
                        <td>(G)</td>
                        <td>
                          Excess Amount Settled (apart from margins) on{" "}
                          {this.state.ExcessAmountSettledOn}
                        </td>
                        <td className="align-right">
                          {this.state.ExcessFundsSettlementAmount}
                        </td>
                        <td className="align-right"></td>
                      </tr>
                      <tr>
                        <td>(H) = (F)+ (G)</td>
                        <td>
                          Total Settlement made on{" "}
                          {this.state.TotalSettlementMadeOn}
                        </td>
                        <td className="align-right">
                          {this.state.TotalSettlementAmount}
                        </td>
                        <td className="align-right"></td>
                      </tr>
                    </tbody>
                  </table>
                  <div>
                    <i>
                      ** A positive value denotes additional value required for
                      optimal assortment. A negative value denotes value for
                      ideal assortment is already present and the excess will be
                      settled as per the settlement cycle.
                    </i>
                  </div>
                  <br />
                </>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}

export default WidgetPincodeSmartDashboard;
